module.exports = __webpack_public_path__ + "static/lframe-brokers-8d4d53674cae5a99d064c08a2df725d9.png";